<template>
    <tasks-find
        :params="{
            task: $route.params.task
        }"
        :include="[
            'note'
        ]"
        v-slot="{
            sid,
            data: task,
            error,
            is_loading,
            has_loaded,
            find
        }"
    >
        <div>
            <template v-if="!has_loaded || error">
                <base-loading
                    :error="error"
                    :retry="find"
                    class="py-6"
                />

                <error-modal
                    v-if="error"
                    :error="error"
                />
            </template>

            <template v-else>
                <div class="mb-6 rounded shadow id-details-card bg-grey-bg">
                    <header class="flex items-center px-4 bg-white border-b rounded-t h-18 sm:px-6">
                        <div class="flex-none mr-3">
                            <task-complete-checkbox
                                :task="task"
                            />
                        </div>

                        <div class="flex-grow mr-3 overflow-hidden">
                            <h1 class="text-lg font-normal truncate">
                                {{ task.title }}
                            </h1>
                        </div>

                        <div
                            v-if="is_loading"
                            class="w-6 h-6 mr-3"
                        >
                            <base-svg
                                name="icon-loading"
                                class="w-full h-full"
                            />
                        </div>

                        <edit-dropdown
                            :task="task"
                            class="flex-none id-edit-dropdown"
                            @success="find"
                        />
                    </header>

                    <div class="px-4 py-3 sm:px-6 md:py-4">
                        <grid-layout class="-mt-3">
                            <grid-layout-item class="mt-3">
                                <div class="text-xs tracking-wide uppercase text-grey-darker">Title</div>

                                <div class="text-sm">
                                    {{ task.title }}
                                </div>
                            </grid-layout-item>

                            <grid-layout-item class="mt-3">
                                <div class="text-xs tracking-wide uppercase text-grey-darker">Description</div>

                                <div class="text-sm">
                                    {{ task.description }}
                                </div>
                            </grid-layout-item>
                        </grid-layout>
                    </div>
                </div>

                <notes-card
                    :note="task.note"
                    :notable="task"
                    class="mb-6"
                />
            </template>
        </div>
    </tasks-find>
</template>

<script>
    import EditDropdown from './show/edit-dropdown'
    import NotesCard from '../../../../components/notes-card'
    import TaskCompleteCheckbox from '../../../../components/task-complete-checkbox'
    import TasksFind from '../../../../components/tasks-find'

    export default {
        components: {
            EditDropdown,
            NotesCard,
            TaskCompleteCheckbox,
            TasksFind
        }
    }
</script>
